var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5419 0H5.39355C3.96309 0 2.59122 0.473539 1.57973 1.31644C0.568247 2.15935 0 3.30258 0 4.49462V49.4409C0 50.6329 0.568247 51.7761 1.57973 52.619C2.59122 53.4619 3.96309 53.9355 5.39355 53.9355H48.5419C49.9724 53.9355 51.3443 53.4619 52.3557 52.619C53.3672 51.7761 53.9355 50.6329 53.9355 49.4409V4.49462C53.9355 3.30258 53.3672 2.15935 52.3557 1.31644C51.3443 0.473539 49.9724 0 48.5419 0ZM48.5419 49.4409H5.39355V4.49462H48.5419V49.4409Z",
    fill: "#077CA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7871 8.98924H43.1484V13.4839H10.7871V8.98924ZM10.7871 17.9785H29.6645V22.4731H10.7871V17.9785ZM16.1807 44.9462H37.7548L26.9678 38.2043L16.1807 44.9462ZM45.8452 42.6989V29.215L32.3613 35.957L45.8452 42.6989ZM10.7871 29.215V42.6989L21.5742 35.957L10.7871 29.215ZM37.7548 26.9677H16.1807L26.9678 33.7097L37.7548 26.9677Z",
    fill: "#077CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesIcon);
export default __webpack_public_path__ + "static/media/TemplatesIcon.868ba974dac85bb9972110e21eafa02e.svg";
export { ForwardRef as ReactComponent };